export const addWatermark = (file, logoUrl) => {
    return new Promise((resolve) => {
        const img = new Image();
        const reader = new FileReader();

        reader.onload = (e) => {
            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d');

                // Dessiner la photo
                ctx.drawImage(img, 0, 0);

                // Charger le logo
                const logo = new Image();
                logo.onload = () => {
                    // Taille du watermark — 8% de la largeur de la photo
                    const watermarkWidth = img.width * 0.04;
                    const watermarkHeight = (logo.height / logo.width) * watermarkWidth;

                    // Position — coin inférieur droit avec padding
                    const x = img.width - watermarkWidth - (img.width * 0.02);
                    const y = img.height - watermarkHeight - (img.height * 0.02);

                    // Opacité du watermark
                    ctx.globalAlpha = 0.5;
                    ctx.drawImage(logo, x, y, watermarkWidth, watermarkHeight);
                    ctx.globalAlpha = 1.0;

                    canvas.toBlob((blob) => {
                        const watermarkedFile = new File([blob], file.name, { type: 'image/jpeg' });
                        resolve(watermarkedFile);
                    }, 'image/jpeg', 0.92);
                };
                logo.src = logoUrl;
            };
            img.src = e.target.result;
        };
        reader.readAsDataURL(file);
    });
};